<template>
  <div class="bg-white pl-3 x-3 pt-5 pb-5 h-100 w-auto shadow-sm">
    <h4 class="pl-5 mb-lg-5">Opciones</h4>
    <ul class="m-0 pl-5 pr-3">
      <li class="text-secondary pr-3 pb-3 cursor-pointer">
        <span class="material-icons icons text-blue">chevron_right</span>
        <router-link :to="'/mis-datos'">Mis Datos</router-link>
      </li>
      <li v-show="canSell" class="text-secondary pr-3 pb-3 cursor-pointer">
        <span class="material-icons icons text-blue">chevron_right</span>
        <router-link :to="{ name: 'Publications' }"
          >Mis Publicaciones</router-link
        >
      </li>
      <li class="text-secondary pr-3 pb-3 cursor-pointer">
        <span class="material-icons icons text-blue">chevron_right</span>
        <router-link :to="'/mis-compras'">Mis Compras</router-link>
      </li>
      <li v-show="canSell" class="text-secondary pr-3 pb-3 cursor-pointer">
        <span class="material-icons icons text-blue">chevron_right</span>
        <router-link :to="'/mis-ventas'">Mis Ventas</router-link>
      </li>
      <li v-show="canSell" class="text-secondary pr-3 pb-3 cursor-pointer">
        <span class="material-icons icons text-blue">chevron_right</span>
        <router-link :to="{ name: 'MyBalance' }">Mi Balance</router-link>
      </li>
      <!-- <li class="text-secondary pr-3 pb-3 cursor-pointer">
        <span class="material-icons icons text-blue">chevron_right</span>
        <s>Editar mis datos</s>
      </li> -->
      <li
        class="text-secondary pr-3 pb-3 cursor-pointer cursor-pointer"
        @click="Logout()"
      >
        <span class="material-icons icons text-blue">chevron_right</span>
        <a href="#">Salir</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  data(){
    return {
      canSell: false,
    }
  },

  methods: {
    ...mapMutations(["deleteAuth"]),
    Logout() {
      this.deleteAuth();
      this.$router.push("/");
    },
  },
    computed: {
    ...mapState(["auth"]),
  },
  created: async function () {
    this.canSell = this.auth.posicion != "Usuario";
  },
  
};
</script>

<style scoped>
.text-secondary a {
  color: #172b46 !important;
  font-weight: bold;
}
</style>